export default __webpack_public_path__ + "4c138365486c58e32be2bed5ed5f593d.svg";